export default __webpack_public_path__ + "static/media/naBtn.6f640af4.svg";